"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./answer.schema"), exports);
__exportStar(require("./answers.schema"), exports);
__exportStar(require("./calculator.schema"), exports);
__exportStar(require("./calculator-group.schema"), exports);
__exportStar(require("./calculator-groups.schema"), exports);
__exportStar(require("./calculators.schema"), exports);
__exportStar(require("./candidate.schema"), exports);
__exportStar(require("./candidates.schema"), exports);
__exportStar(require("./candidates-answers.schema"), exports);
__exportStar(require("./district.schema"), exports);
__exportStar(require("./election.schema"), exports);
__exportStar(require("./elections.schema"), exports);
__exportStar(require("./images.schema"), exports);
__exportStar(require("./organization.schema"), exports);
__exportStar(require("./organizations.schema"), exports);
__exportStar(require("./person.schema"), exports);
__exportStar(require("./persons.schema"), exports);
__exportStar(require("./question.schema"), exports);
__exportStar(require("./questions.schema"), exports);
__exportStar(require("./round.schema"), exports);
__exportStar(require("./tags.schema"), exports);
__exportStar(require("./time-period.schema"), exports);
__exportStar(require("./variant.schema"), exports);
